module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('form-wizard', {
    attrs: {
      "shape": "tab",
      "color": "#9b59b6",
      "title": "Info erstellen",
      "subtitle": "",
      "nextButtonText": "Weiter",
      "backButtonText": "Zurück",
      "finishButtonText": "Erstellen"
    },
    on: {
      "on-complete": _vm.onWizardComplete
    }
  }, [_c('tab-content', {
    attrs: {
      "title": "Allgemeine Einstellungen",
      "icon": "fa fa-cogs"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "infoProjectName"
    }
  }, [_vm._v("Info-Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.infoProjectName),
      expression: "infoProjectName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "infoProjectName"
    },
    domProps: {
      "value": (_vm.infoProjectName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.infoProjectName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Vorschaubild:")]), _vm._v(" "), _c('vue-dropzone', {
    ref: "previewImageDropzone",
    attrs: {
      "id": "previewImageDropzone",
      "options": _vm.previewDropzoneImage
    },
    on: {
      "vdropzone-queue-complete": _vm.previewUploadComplete,
      "vdropzone-sending": _vm.previewImageSending
    }
  })], 1)]), _vm._v(" "), _c('tab-content', {
    attrs: {
      "title": "Inhalte hochladen",
      "icon": "fa fa-upload"
    }
  }, [_c('vue-dropzone', {
    ref: "pageDropzone",
    attrs: {
      "id": "dropzone",
      "options": _vm.PagedropzoneOptions
    },
    on: {
      "vdropzone-sending": _vm.pageDropzoneSending,
      "vdropzone-queue-complete": _vm.pageUploadComplete
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-745a3f31"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/InfoProjectImport.vue
// module id = 128
// module chunks = 0